import React from "react";

export const ContentColouredText = (props: any) => (
  <span
    {...props}
    style={{
      color: props.hex ?? "inherit",
    }}
  />
);
